export default (function () {
  var baseUrl = getBaseUrl()
  return baseUrl
})()

function getBaseUrl() {
  var baseUrl = 'https://ap-socket.gladmobile.com/'
  if (location.href.includes('localhost')) {
    baseUrl = 'https://staging.ap.gladmobile.com/'
  } else if (location.href.includes('staging.backstage.gladmobile.com')) {
    baseUrl = 'https://staging.ap.gladmobile.com/'
  }
  return baseUrl
}



// WEBPACK FOOTER //
// ./src/assets/js/libs/Socket.js